import {DialogFragment, DialogFragmentProps, DialogFragmentState} from "../shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledBoxRow} from "../shared/StyledComponents";
import {DIVIDER_BLACK, PAGE_FRAGMENT_LG_WIDTH, PD_LG} from "../shared/dimens";
import {Button, Grid, Slider, Typography} from "@mui/material";
import {Codabot, CODABOT_KTM} from "./types";
import {BaseApp} from "../shared/BaseApp";
import {AppPrefs} from "./app_prefs";

export class SettingsHelper {

  static showSettings(): void {
    BaseApp.CONTEXT.showDialog(null, () => <SettingsFragment/>);
  }
}

type SettingsFragmentProps = DialogFragmentProps & {}

type SettingsFragmentState = DialogFragmentState & {
  codabot: Codabot,
  speed: number,
}

class SettingsFragment extends DialogFragment<SettingsFragmentProps, SettingsFragmentState> {


  protected onCreateState(): SettingsFragmentState {
    const appPrefs = AppPrefs.getInstance();
    return {
      ...super.onCreateState(),
      codabot: appPrefs.getCodabot(),
      speed: appPrefs.getSpeed(),
    };
  }

  componentDidUpdate(prevProps: Readonly<SettingsFragmentProps>, prevState: Readonly<SettingsFragmentState>, snapshot?: any) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    if (prevState.codabot !== this.state.codabot) {
      AppPrefs.getInstance().setCodabot(this.state.codabot);
    }
    if (prevState.speed !== this.state.speed) {
      AppPrefs.getInstance().setSpeed(this.state.speed);
    }
  }

  private renderInContainer(title: string, children: ReactElement): ReactElement {
    return <StyledBoxColumn style={{padding: PD_LG,}}>
      <Typography><b>{title}</b></Typography>
      {children}
    </StyledBoxColumn>;
  }

  renderContent(): ReactElement {
    return <StyledBoxColumn style={{width: "90vw", maxWidth: PAGE_FRAGMENT_LG_WIDTH, gap: 0}}>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderBottom: DIVIDER_BLACK}}>
        <Typography variant={"h5"}>Settings</Typography>
      </StyledBoxRow>
      <StyledBoxColumn style={{padding: PD_LG}}>
        {this.renderInContainer("Codabot", <Grid container>
          {Object.getOwnPropertyNames(Codabot).map(name => {
            const codabot = Codabot[name];
            const metadata = CODABOT_KTM.findMetadata(codabot);
            return <Grid xs={6} md={3} style={{padding: PD_LG}}>
              <Button
                onClick={() => this.setState({codabot: codabot})}
                color={"secondary"} variant={this.state.codabot === codabot ? "contained" : null}
                style={{padding: 0, width: "100%"}}>
                <StyledBoxColumn style={{width: "100%", padding: PD_LG}}>
                  <img src={metadata.spriteIconUrl} style={{width: "100%", aspectRatio: 1}}/>
                  <Typography>{metadata.text}</Typography>
                </StyledBoxColumn>
              </Button>
            </Grid>
          })}
        </Grid>)}
        {this.renderInContainer("Speed", <StyledBoxRow style={{alignItems: "center"}}>
          <Slider min={1} max={20} value={this.state.speed}
                  onChange={(event, newValue) => this.setState({speed: newValue as number})}
                  style={{margin: PD_LG, flexBasis: 0, flexGrow: 1}}/>
          <Typography variant={"h6"}>{this.state.speed}</Typography>
        </StyledBoxRow>)}
      </StyledBoxColumn>
    </StyledBoxColumn>;
  }
}